import Loadable from 'layouts/full/shared/loadable/Loadable';
import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';

/* ****Pages***** */
// Private pages
const Analytics = Loadable(lazy(() => import('pages/dashboard')));
const Transaction = Loadable(lazy(() => import('pages/transaction')));
const TransactionDetail = Loadable(lazy(() => import('pages/transaction/detail')));
const QrisPayment = Loadable(lazy(() => import('pages/transaction/qris-payment')));
const QrisPaymentDetail = Loadable(lazy(() => import('pages/transaction/qris-payment/detail')));
const CheckQris = Loadable(lazy(() => import('pages/transaction/qris-payment/check-qr')));
const ChangePassword = Loadable(lazy(() => import('pages/changepassword')));
const Settlement = Loadable(lazy(() => import('pages/settlement')));
const SettlementDetail = Loadable(lazy(() => import('pages/settlement/detail')));
const Logs = Loadable(lazy(() => import('pages/logs')));
const PaymentLink = Loadable(lazy(() => import('pages/payment-link')));
const PaymentLinkDetail = Loadable(lazy(() => import('pages/payment-link/[id]')));
const Member = Loadable(lazy(() => import('pages/member')));
const MemberDetail = Loadable(lazy(() => import('pages/member/[id]')));

const AccountGroup = Loadable(lazy(() => import('pages/user/account-group')));
const AccountGroupDetail = Loadable(lazy(() => import('pages/user/account-group/detail')));
const Business = Loadable(lazy(() => import('pages/business')));
const BusinessDetail = Loadable(lazy(() => import('pages/business/detail')));
const SetupDefaultFees = Loadable(lazy(() => import('pages/business/setupDefaultFees')));
const BusinessFeeRate = Loadable(lazy(() => import('pages/business/businessFee')));
const CreateBusiness = Loadable(lazy(() => import('pages/business/create')));
const Merchant = Loadable(lazy(() => import('pages/merchant')));
const MerchantDetail = Loadable(lazy(() => import('pages/merchant/detail-merchant')));
const CreateMerchant = Loadable(lazy(() => import('pages/merchant/create-merchant')));

const CreatePaymentLink = Loadable(lazy(() => import('pages/create-payment-link')));

const Profile = Loadable(lazy(() => import('pages/profile')));

const Settings = Loadable(lazy(() => import('pages/settings')));
const CreateWebhook = Loadable(lazy(() => import('pages/settings/create-webhook')));

const InviteNewAdmin = Loadable(lazy(() => import('pages/invite-new-admin')));
const VA = Loadable(lazy(() => import('pages/virtual-account')));
const VADetail = Loadable(lazy(() => import('pages/virtual-account/[id]')));
const VAReconciliation = Loadable(lazy(() => import('pages/virtual-account/va-reconciliation')));
const Ewallet = Loadable(lazy(() => import('pages/ewallet')));
const EwalletDetail = Loadable(lazy(() => import('pages/ewallet/[id]')));

const Disbursement = Loadable(lazy(() => import('pages/disbursement')));
const DisbursementDetail = Loadable(lazy(() => import('pages/disbursement/[id]')));
const DisbursementCheckStatus = Loadable(lazy(() => import('pages/disbursement/check-status')));

const DisbursementMonitoring = Loadable(lazy(() => import('pages/disbursement-monitoring')));

const Withdrawal = Loadable(lazy(() => import('pages/withdrawal')));
const CreateWithdrawal = Loadable(lazy(() => import('pages/withdrawal/createWithdrawal')));
const WithdrawalDetail = Loadable(lazy(() => import('pages/withdrawal/detail')));
const ManualDisbursement = Loadable(lazy(() => import('pages/manual-disbursement')));
const ManualDisbursementBulkPending = Loadable(
  lazy(() => import('pages/manual-disbursement/pending/BulkPendingDisbursement')),
);
const ManualDisbursementBulkApproval = Loadable(
  lazy(() => import('pages/manual-disbursement/approval/BulkApprovalDisbursement')),
);

const CheckReconcile = Loadable(lazy(() => import('pages/secret-page/check-reconcile')));
const ReconcileUpload = Loadable(lazy(() => import('pages/reconcile-upload')));
const FourZeroFour = Loadable(lazy(() => import('pages/z-error/404')));

const Complaint = Loadable(lazy(() => import('pages/costumer-service/complaint')));
const CreateComplaint = Loadable(lazy(() => import('pages/costumer-service/createComplaint')));
const DetailComplaint = Loadable(lazy(() => import('pages/costumer-service/detail')));

const FinancialTransactions = Loadable(lazy(() => import('pages/financial-transactions')));

const DisbursementSetting = Loadable(lazy(() => import('pages/disbursement-setting')));
const ProviderActivationDetail = Loadable(
  lazy(() => import('pages/disbursement-setting/provider-activation/detail')),
);
const PaymentSetting = Loadable(lazy(() => import('pages/payment-setting')));
const PaymentSettingConnect = Loadable(lazy(() => import('pages/payment-setting/Connect-setting')));
const ProviderActivationBusinessMapping = Loadable(
  lazy(() =>
    import(
      'pages/disbursement-setting/provider-activation/business-section/business-mapping-section'
    ),
  ),
);
const GenerateQRIS = Loadable(lazy(() => import('pages/generate-qr')));
const PaymentTesting = Loadable(lazy(() => import('pages/testing-tools')));

const PaymentGateway = Loadable(lazy(() => import('pages/payment-gateway')));
const PaymentGatewayMaintenanceSchedule = Loadable(
  lazy(() => import('pages/payment-gateway/pg-maintenance')),
);
const DepositVA = Loadable(lazy(() => import('pages/depositVA')));
const DepositVADetail = Loadable(lazy(() => import('pages/depositVA/[id]')));
const CreditCard = Loadable(lazy(() => import('pages/credit-card')));
const CreditCardDetail = Loadable(lazy(() => import('pages/credit-card/[id]')));
const BeneficiaryAccount = Loadable(lazy(() => import('pages/beneficiary-account')));
const BeneficiaryAccountDetail = Loadable(lazy(() => import('pages/beneficiary-account/[id]')));
const AdjustmentBalance = Loadable(lazy(() => import('pages/adjustment-balance')));
const ProviderBalance = Loadable(lazy(() => import('pages/provider-balance')));
const ProviderBalanceTransfer = Loadable(lazy(() => import('pages/provider-balance-transfer')));
const ProviderBalanceTransferDetail = Loadable(
  lazy(() => import('pages/provider-balance-transfer/detail/[id]')),
);
const CreateAdjustmentBalance = Loadable(
  lazy(() => import('pages/adjustment-balance/ops/createAdjustmentBalance')),
);
const CreateAdjustmentTopUp = Loadable(
  lazy(() => import('pages/adjustment-balance/release/createTopUp')),
);
const DetailAdjustmentBalance = Loadable(
  lazy(() => import('pages/adjustment-balance/history/detail')),
);
const CashIn = Loadable(lazy(() => import('pages/cashIn')));
const CashOut = Loadable(lazy(() => import('pages/cashOut')));

const CashInPayment = Loadable(lazy(() => import('pages/cashIn/payment')));
const CashInBusiness = Loadable(lazy(() => import('pages/cashIn/business')));
const CashInMerchant = Loadable(lazy(() => import('pages/cashIn/merchant')));
const Reconcile = Loadable(lazy(() => import('pages/secret-page')));
const DetailPgMaintenance = Loadable(
  lazy(() => import('pages/payment-gateway/pg-maintenance/detail-pg-maintenance')),
);
const PaymentGlobalRouting = Loadable(
  lazy(() => import('pages/settings/payment-global-routing')),
);
const DirectDebit = Loadable(lazy(() => import('pages/direct-debit')));
const DirectDebitDetail = Loadable(lazy(() => import('pages/direct-debit/[id]')));
const PaymentGatewayConfigure = Loadable(lazy(() => import('pages/Payment-gateway-configure')));

// Reversal Transaction
const ReversalTransaction = Loadable(lazy(() => import('pages/transaction-reversal')));

const Balance = Loadable(lazy(() => import('pages/balance')));

// Banner Announcement
const MerchantAnnouncement = Loadable(lazy(() => import('pages/merchant-announcement')));
const DTTOT = Loadable(lazy(() => import('pages/DTTOT')));

// NEW PAGES

const WalkinService = Loadable(lazy(() => import('pages/walkin-service')));

const BusinessFeatureConfiguration = Loadable(
  lazy(() => import('pages/business-feature-configuration')),
);

// Public pages
const VerifyLogin = Loadable(lazy(() => import('pages/Authentication/login-otp-verification')));
const Register = Loadable(lazy(() => import('pages/Authentication/register')));
const Login = Loadable(lazy(() => import('pages/Authentication/login')));
const VerificationEmail = Loadable(lazy(() => import('pages/Authentication/verification-email')));
const VerificationEmailCheck = Loadable(
  lazy(() => import('pages/Authentication/verification-email-check')),
);
const ForgotPassword = Loadable(lazy(() => import('pages/Authentication/forgot-password')));
const ResetPassword = Loadable(lazy(() => import('pages/Authentication/reset-password')));
const ResendEmail = Loadable(lazy(() => import('pages/Authentication/resend-email')));
const AdminRoles = Loadable(lazy(() => import('pages/user-roles')));
// Public Holiday Configuration
const PublicHolidayConfiguration = Loadable(
  lazy(() => import('pages/public-holiday-configuration/public-holiday-configuration')),
);

const FdsPage = Loadable(lazy(() => import('pages/fds')));
const UserAccessManagement = Loadable(lazy(() => import('pages/settings/user-management')));
const SuccessFlagging = Loadable(lazy(() => import('pages/costumer-service-flagging')));

const authProtectedRoutes = [
  { path: '*', element: <FourZeroFour /> },
  { path: '/', element: <Navigate to="/dashboard" /> },
  { path: '/dashboard', exact: true, element: <Analytics />, name: 'Dashboard' },
  { path: '/analytics', element: <Analytics /> },
  { path: '/changepassword', element: <ChangePassword />, name: 'Profile' },
  { path: '/transaction', element: <Transaction />, name: 'Transaction Reports' },
  { path: '/transaction/cash-in-detail', element: <CashIn />, name: 'Cash In Detail' },
  { path: '/cash-in-detail/:payment_channel', element: <CashInPayment /> },
  { path: '/cash-in-detail/:id/:businessId', element: <CashInBusiness /> },
  { path: '/cash-in-detail/:id/:businessId/:merchantId', element: <CashInMerchant /> },
  { path: '/qris-payment', element: <QrisPayment />, name: 'QRIS Payment' },
  { path: '/qris-payment/:id', element: <QrisPaymentDetail />, name: 'QRIS Payment Detail' },
  {
    path: '/qris-payment/check-status-qr',
    element: <CheckQris />,
    name: 'QRIS Payment Check Status',
  },
  {
    path: '/transaction/:businessId/:id',
    element: <TransactionDetail />,
    name: 'Transaction Detail',
  },
  { path: '/settlement', element: <Settlement />, name: 'Settlement' },
  { path: '/settlement/:type', element: <Settlement />, name: 'Settlement' },
  { path: '/settlement/detail', element: <SettlementDetail />, name: 'Settlement Detail' },
  { path: '/payment-gateway', element: <PaymentGateway />, name: 'Payment Gateway' },
  {
    path: '/payment-gateway/:pgId/maintenance-schedule',
    element: <PaymentGatewayMaintenanceSchedule />,
    name: 'Payment Gateway Maintenance Schedule',
  },
  {
    path: '/payment-gateway-maintenance/:id',
    element: <DetailPgMaintenance />,
    name: 'Payment Gateway Maintenance Detail',
  },
  { path: '/logs', element: <Logs /> },
  { path: '/payment-link', element: <PaymentLink /> },
  { path: '/payment-link/:id', element: <PaymentLinkDetail /> },
  { path: '/create-payment-link', element: <CreatePaymentLink />, name: 'Create Payment Link' },
  { path: '/user', element: <Member />, name: 'Member' },
  { path: '/user/:id', element: <MemberDetail />, name: 'Member Detail' },

  { path: '/account-group', element: <AccountGroup />, name: 'Account Group' },
  { path: '/account-group/:id', element: <AccountGroupDetail />, name: 'Account Group Detail' },
  { path: '/merchant', element: <Merchant />, name: 'Merchant' },
  { path: '/merchant/:id', element: <MerchantDetail />, name: 'Merchant Detail' },
  {
    path: '/merchant/edit-merchant/:businessId/:merchantId',
    element: <CreateMerchant />,
  },
  { path: '/business', element: <Business />, name: 'Business' },
  { path: '/business/:id', element: <BusinessDetail />, name: 'Business Detail' },
  { path: '/business/create-business', element: <CreateBusiness />, name: 'Create Business' },
  { path: '/business/:id/product-fee', element: <BusinessFeeRate />, name: 'Business Fee' },
  {
    path: '/business/:id/create-merchant',
    element: <CreateMerchant />,
    name: 'Business (Create Merchant)',
  },
  {
    path: '/business/setup-default-fees',
    element: <SetupDefaultFees />,
    name: 'Setup Default Fees',
  },
  { path: '/profile', element: <Profile />, name: 'Profile' },
  // { path: '/add-user', element: <User /> },
  { path: '/settings', element: <Settings /> },
  { path: '/settings/create-webhook', element: <CreateWebhook /> },
  { path: '/settings/user-access-management', element: <UserAccessManagement /> },
  { path: '/settings/user-access-management/:type', element: <UserAccessManagement /> },
  { path: '/invite-new-admin', element: <InviteNewAdmin /> },
  { path: '/virtual-account', element: <VA />, name: 'Virtual Account' },
  { path: '/virtual-account/:id', element: <VADetail />, name: 'Virtual Account Detail' },
  {
    path: '/virtual-account/reconciliation',
    element: <VAReconciliation />,
    name: 'Virtual Account Reconciliation',
  },
  { path: '/ewallet', element: <Ewallet />, name: 'E-Wallet' },
  { path: '/ewallet/:id', element: <EwalletDetail />, name: 'E-Wallet Detail' },
  { path: '/withdrawal', element: <Withdrawal />, name: 'Withdrawal' },
  { path: '/withdrawal/:type', element: <Withdrawal />, name: 'Withdrawal' },
  {
    path: '/withdrawal/create-withdrawal',
    element: <CreateWithdrawal />,
    name: 'Create Withdrawal',
  },
  { path: '/withdrawal/detail/:id', element: <WithdrawalDetail />, name: 'Withdrawal Detail' },
  { path: '/manual-disbursement', element: <ManualDisbursement />, name: 'Manual Disbursement' },
  {
    path: '/manual-disbursement/:type',
    element: <ManualDisbursement />,
    name: 'Manual Disbursement',
  },
  {
    path: '/manual-disbursement/bulk-pending',
    element: <ManualDisbursementBulkPending />,
    name: 'Manual Disbursement Bulk Pending',
  },
  {
    path: '/manual-disbursement/bulk-approval',
    element: <ManualDisbursementBulkApproval />,
    name: 'Manual Disbursement Bulk Approval',
  },
  { path: '/disbursement', element: <Disbursement />, name: 'Disbursement' },
  { path: '/disbursement/:id', element: <DisbursementDetail />, name: 'Disbursement Detail' },
  {
    path: '/disbursement-monitoring',
    element: <DisbursementMonitoring />,
    name: 'Monitoring',
  },
  { path: '/check-reconcile', element: <CheckReconcile />, name: 'Check Reconcile' },
  { path: '/generate-qr', element: <GenerateQRIS />, name: 'Generate QRIS' },
  { path: '/complaint', element: <Complaint />, name: 'Complaint' },
  { path: '/complaint/create-complaint', element: <CreateComplaint />, name: 'Create Complaint' },
  { path: '/complaint/:id', element: <DetailComplaint />, name: 'Complaint Detail' },
  { path: '/complaint/edit-complaint/:id', element: <CreateComplaint />, name: 'Edit Complaint' },
  {
    path: '/disbursement-setting',
    element: <DisbursementSetting />,
    name: 'Disbursement',
    nameFromQuery: true,
  },
  {
    path: '/disbursement-setting/provider-activation-detail/:id',
    element: <ProviderActivationDetail />,
    name: 'Provider Activation Business Routing',
  },
  { path: '/payment-setting', element: <PaymentSetting />, name: 'Payment Setting' },
  {
    path: '/payment-setting/connect/:id',
    element: <PaymentSettingConnect />,
    name: 'Payment Setting Connect',
  },

  {
    path: '/financial-transaction',
    element: <FinancialTransactions />,
    name: 'Financial Transaction',
  },
  { path: '/deposit-va', element: <DepositVA />, name: 'Deposit Virtual Account' },
  { path: '/deposit-va/:id', element: <DepositVADetail />, name: 'Deposit Virtual Account Detail' },
  { path: '/credit-card', element: <CreditCard />, name: 'Credit Card' },
  { path: '/credit-card/:id', element: <CreditCardDetail />, name: 'Credit Card Detail' },
  { path: '/adjustment-balance', element: <AdjustmentBalance />, name: 'Adjustment Balance' },
  { path: '/adjustment-balance/:type', element: <AdjustmentBalance />, name: 'Adjustment Balance' },
  {
    path: '/disbursements/check-status',
    element: <DisbursementCheckStatus />,
    name: 'Disbursement Check Status',
  },
  { path: '/disbursement/cash-out-detail', element: <CashOut /> },
  {
    path: '/adjustment-balance/create',
    element: <CreateAdjustmentBalance />,
    name: 'Create Adjustment Balance',
  },
  {
    path: '/adjustment-balance/detail/:id',
    element: <DetailAdjustmentBalance />,
    name: 'Adjustment Balance Detail',
  },
  {
    path: '/adjustment-balance/topup',
    element: <CreateAdjustmentTopUp />,
    name: 'Top Up Adjustment Balance',
  },
  { path: '/provider-balance', element: <ProviderBalance />, name: 'Provider Balance & History' },
  {
    path: '/provider-balance-transfer',
    element: <ProviderBalanceTransfer />,
    name: 'Provider Balance Transfer',
  },
  {
    path: '/provider-balance-transfer/detail/:id',
    element: <ProviderBalanceTransferDetail />,
    name: 'Provider Balance Transfer Detail',
  },
  { path: '/reconcile', element: <Reconcile />, name: 'Reconcile' },
  { path: '/reconcile/:type', element: <Reconcile />, name: 'Reconcile Detail' },
  { path: '/direct-debit', element: <DirectDebit />, name: 'Direct Debit' },
  { path: '/direct-debit/:id', element: <DirectDebitDetail />, name: 'Direct Debit Detail' },
  { path: '/role-management', element: <AdminRoles />, name: 'Role Management' },
  { path: '/dttot', element: <DTTOT />, name: 'DTTOT' },
  { path: '/transaction-reversal', element: <ReversalTransaction />, name: 'Transaction Reversal' },
  {
    path: '/transaction-reversal/:type',
    element: <ReversalTransaction />,
    name: 'Transaction Reversal Detail',
  },
  { path: '/cash-flow', element: <Balance />, name: 'Cash Flow' },
  { path: '/walkin-service', element: <WalkinService />, name: 'Walk-in Service' },
  {
    path: '/payment-gateway-config',
    element: <PaymentGatewayConfigure />,
    name: 'Payment Gateway Configuration',
  },
  { path: '/testing-tools', element: <PaymentTesting />, name: 'Testing Tools' },

  // { path: '/financial-transactions', element: <FinancialTransactions /> },
  {
    path: '/disbursement-setting/provider-activation-business-mapping',
    element: <ProviderActivationBusinessMapping />,
  },
  { path: '/financial-transaction', element: <FinancialTransactions /> },
  { path: '/beneficiary-account', element: <BeneficiaryAccount  />, name: 'Beneficiary Account' },
  { path: '/beneficiary-account/:id', element: <BeneficiaryAccountDetail />, name: 'Beneficiary Account Detail' },
  { path: '/disbursements/check-status/:type', element: <DisbursementCheckStatus /> },
  { path: '/holiday', element: <PublicHolidayConfiguration /> },
  { path: '/merchant-announcement', element: <MerchantAnnouncement /> },
  { path: '/reconcile-upload', element: <ReconcileUpload /> },
  { path: '/direct-debit', element: <DirectDebit /> },
  { path: '/direct-debit/:id', element: <DirectDebitDetail /> },
  { path: '/dttot', element: <DTTOT /> },
  { path: '/transaction-reversal', element: <ReversalTransaction /> },
  { path: '/transaction-reversal/:type', element: <ReversalTransaction /> },
  { path: '/cash-flow', element: <Balance /> },
  { path: '/payment-gateway-config', element: <PaymentGatewayConfigure /> },
  { path: '/business/:id/feature-configuration', element: <BusinessFeatureConfiguration /> },
  { path: '/fds-parameters', element: <FdsPage /> },
  { path: '/success-flagging', element: <SuccessFlagging /> },
  { path: '/success-flagging/:type', element: <SuccessFlagging /> },
  { path: '/success-flagging/:type/:objectId', element: <SuccessFlagging /> },
  {
    path: '/settings/payment-global-routing',
    element: <PaymentGlobalRouting />,
  },
];

const publicRoutes = [
  { path: '/login', element: <Login /> },
  { path: '/login/verify-otp', element: <VerifyLogin /> },
  { path: '/verification-email/:token', element: <VerificationEmail /> },
  { path: '/verification-email-check', element: <VerificationEmailCheck /> },
  { path: '/forgot-password', element: <ForgotPassword /> },
  { path: '/auth/reset-password/:token', element: <ResetPassword /> },
  { path: '/resend-email', element: <ResendEmail /> },
];

export { authProtectedRoutes, publicRoutes };
